<template>
  <div class="app-success">
    <slot name="txtBefore">Success</slot>
    <b-form>
      <b-button :href="backButtonHref" class="btn-back" type="button" variant="primary" @click="back">
        <slot name="btnSuccessBack">Zurück</slot>
      </b-button>
    </b-form>
    <LogOut v-if="showLogout"></LogOut>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import { BButton, BForm } from 'bootstrap-vue'
import LogOut from './LogOut'

export const stepName = 'success'

export default {
  name: 'Success',
  components: { LogOut, BButton, BForm },
  props: {
    backButtonHref: {
      Type: String,
      Default: '#'
    },
    back: {
      Type: Function,
      Default: () => () => {}
    },
    showLogout: {
      type: Boolean,
      default: false
    }
  }
}
</script>
